import { Loader2 } from "lucide-react";
import { usePageHeader } from "@/components/layouts/lib/page-header";
import { CommissionEditQueueContent } from "./commission-edit-queue/components/CommissionEditQueueContent";
import { CommissionEditQueueIntro } from "./commission-edit-queue/components/CommissionEditQueueIntro";
import { CommissionEditQueueStatsGrid } from "./commission-edit-queue/components/CommissionEditQueueStatsGrid";
import { CommissionEditQueueToolbar } from "./commission-edit-queue/components/CommissionEditQueueToolbar";
import { CommissionEditRequestDetailDialog } from "./commission-edit-queue/components/CommissionEditRequestDetailDialog";
import { COMMISSION_EDIT_QUEUE_GUIDE } from "./commission-edit-queue/commissionEditQueue.constants";
import { useCommissionEditQueueActions } from "./commission-edit-queue/hooks/useCommissionEditQueueActions";
import { useCommissionEditQueueData } from "./commission-edit-queue/hooks/useCommissionEditQueueData";
import { useCommissionEditQueueState } from "./commission-edit-queue/hooks/useCommissionEditQueueState";

export default function CommissionEditQueuePage() {
  const pageState = useCommissionEditQueueState();
  const pageData = useCommissionEditQueueData({
    search: pageState.search,
    statusFilter: pageState.statusFilter,
    typeFilter: pageState.typeFilter,
  });
  const actions = useCommissionEditQueueActions({
    rejectNote: pageState.rejectNote,
    onActionSuccess: (requestId) => {
      pageState.resetRejection();
      pageState.setSelectedContext((current) =>
        current?.request.id === requestId ? null : current,
      );
    },
  });

  usePageHeader({
    title: "Demandes de modification",
    helpTopic: "commissions",
    guide: { steps: COMMISSION_EDIT_QUEUE_GUIDE },
  });

  if (pageData.loadingRequests) {
    return <Loader2 className="animate-spin text-subtle" size={18} />;
  }

  return (
    <div>
      <CommissionEditQueueIntro filteredCount={pageData.filteredContexts.length} />
      <CommissionEditQueueStatsGrid stats={pageData.stats} />
      <CommissionEditQueueToolbar
        search={pageState.search}
        statusFilter={pageState.statusFilter}
        typeFilter={pageState.typeFilter}
        viewMode={pageState.viewMode}
        types={pageData.types}
        onSearchChange={pageState.setSearch}
        onStatusFilterChange={pageState.setStatusFilter}
        onTypeFilterChange={pageState.setTypeFilter}
        onViewModeChange={pageState.setViewMode}
      />
      <CommissionEditQueueContent
        requests={pageData.filteredContexts}
        viewMode={pageState.viewMode}
        busyId={actions.busyId}
        rejectingId={pageState.rejectingId}
        rejectNote={pageState.rejectNote}
        onSelect={pageState.setSelectedContext}
        onApprove={actions.approveRequest}
        onReject={actions.rejectRequest}
        onStartReject={pageState.setRejectingId}
        onRejectNote={pageState.setRejectNote}
      />
      <CommissionEditRequestDetailDialog
        context={pageState.selectedContext}
        busyId={actions.busyId}
        rejectingId={pageState.rejectingId}
        rejectNote={pageState.rejectNote}
        onOpenChange={(open) => {
          if (!open) pageState.closeSelected();
        }}
        onApprove={actions.approveRequest}
        onReject={actions.rejectRequest}
        onStartReject={pageState.setRejectingId}
        onRejectNote={pageState.setRejectNote}
      />
    </div>
  );
}
